import React from 'react';

import { CoreHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import {
	AlternativeStylesPropertiesTypography,
	Box,
	Typography,
	TypographyColorsLevel,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { Check, ArrowRight } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { rem } from '@helpers';
import { useLogger } from '@hooks';
import { Circle } from '@icons';
import { useNavigation } from '@navigation';

import { WizardItem } from './../../wizardMenu.helper';

type TypographyStyles = React.CSSProperties & AlternativeStylesPropertiesTypography;

interface WizardMenuSubItemProps {
	item: WizardItem;
	childIndex: number;
	selectedIndex: number;
	parentIndex: number;
	totalChildrenCount: number;
}

export const WizardMenuSubItem: React.FC<WizardMenuSubItemProps> = (props) => {
	const { item, childIndex, parentIndex, totalChildrenCount, selectedIndex } = props;
	const logger = useLogger();
	const { colorPalette } = useTheme();
	const { navigate } = useNavigation();

	const isCurrentMenu = parentIndex + childIndex === selectedIndex - totalChildrenCount + (childIndex + 1);
	const wasFinished = parentIndex + childIndex < selectedIndex - totalChildrenCount + (childIndex + 1);

	const handleOnClickItem = (wizardItem: WizardItem) => {
		wizardItem.route && navigate(wizardItem.route);
	};

	const startContentSource = (wasFinished && <Check fill={colorPalette.color_02[100]} />) ||
		(isCurrentMenu && <ArrowRight fill={colorPalette.color_02[100]} />) || <Circle />;

	const textColorsLevel: TypographyColorsLevel | undefined = !!wasFinished
		? undefined
		: (isCurrentMenu && 'linkDefault') || 'disabled';

	logger('WizardMenu SUB Item > render', item);

	return (
		<Box
			key={item.route || CoreHelper.guid()}
			styles={{ display: 'flex', flexDirection: 'column' }}
			onPress={wasFinished ? () => handleOnClickItem(item) : undefined}
		>
			<Box styles={{ alignItems: 'center' }}>
				<Box
					styles={{
						width: rem(24),
						height: rem(24),
						alignItems: 'center',
						justifyContent: 'center',
						marginRight: rem(24),
					}}
				>
					{startContentSource}
				</Box>
				<Typography
					appearance={'body-100-02'}
					colorsLevel={textColorsLevel}
					styles={
						{
							marginLeft: rem(8),
							wordBreak: 'break-all',
						} as TypographyStyles
					}
				>
					{item.title}
				</Typography>
			</Box>
		</Box>
	);
};
